// 自动翻译模块路由配置
export const translateMain = [
  {
    name: 'translate',
    path: '/translate',
    meta: {
      title: '自动翻译',
      icon: 'translation'
    }
  },
  {
    name: 'translateLanguages',
    path: '/translate/languages',
    component: () => import('/@/views/plugins/translate/Languages.vue'),
    meta: {
      title: '语言管理',
      icon: 'guide',
      plugin: 'translate'
    }
  }
]

export default translateMain
